<template>
  <section>
    <UserDialog ref="userDialog"/>
    <el-tree
        :data="treeData"
        :show-checkbox="!type"
        :default-expand-all="false"
        node-key="entityId"
        ref="tree"
        highlight-current
        :props="defaultProps"
        :check-strictly="checkStrictly"
        @check="checkChange"
    >
      <span slot-scope="{ node, data }">
        <i v-if="data.funcId" class="el-icon-discount treeIcon"/>
        <i v-if="!data.funcId" class="el-icon-s-unfold treeIcon"/>
        <span>{{ node.label }}</span>
        <span
            v-if="type === 'user'"
            class="primary cur userBtn"
            @click="(e) => showUserDialog(e, data)"
        >查看</span>
      </span>
    </el-tree>
  </section>
</template>

<script>
import handleJurisdiction from '@qx/utils/jurisdiction';
import UserDialog from './userDialog';

export default {
  model: {
    prop: 'treeData', // 父级传进来的值
    event: 'change',
  },
  props: {
    treeData: {
      default: () => ([]),
    },
    type: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UserDialog,
  },
  data () {
    return {
      roleId: '', // 角色id
      defaultProps: {
        children: 'childMenus',
        label: 'menuName',
      },
      checkStrictly: false,
    };
  },
  watch: {
    treeData () {
      handleJurisdiction({
        treeData: this.treeData,
        disabled: this.disabled,
      });
      this.$nextTick(() => {
        const checkData = handleJurisdiction({
          treeData: this.treeData,
          getResult: true,
        });
        this.$refs.tree.setCheckedKeys(checkData);
      });
    },
  },
  methods: {
    getVal () {
      return [
        ...this.$refs.tree.getCheckedKeys(),
        ...this.$refs.tree.getHalfCheckedKeys(),
      ];
    },
    getFullVal () {
      return handleJurisdiction({
        treeData: this.treeData,
        selectData: handleJurisdiction({
          treeData: this.treeData,
          getResult: true,
        }),
      });
    },
    showUserDialog (e, data) {
      e.stopPropagation();
      this.$refs.userDialog.show(data);
    },
    checkChange (data, checkedData) {
      // 优化开始
      let nowDataList = this.$refs.tree.getCheckedKeys();
      let nowDataName = this.$refs.tree.getCheckedNodes();
      const optimizeSelection = (id, entityId, parentId) => {
        if (nowDataList.includes(id)) {
          let _index = nowDataList.findIndex((item) => item === (data.entityId === entityId ? parentId : entityId));
          if (_index >= 0) {
            nowDataList.splice(_index, 1);
            nowDataList.splice(nowDataList.findIndex((item) => item === id), 1);
          }
          this.$refs.tree.setCheckedKeys(nowDataList);
        } else {
          this.checkStrictly = false;
        }
      };
      optimizeSelection(1000000000, 1000000002, 1000000001);
      optimizeSelection(1000000200, 1000000202, 1000000201);
    },

  },
};
</script>

<style scoped lang="scss">
.treeIcon {
  margin-right: 4px;
}

.userBtn {
  margin-left: 16px;
}
</style>
